export default "__VITE_ASSET__Dk3FQhyu__"